import { Injectable, Pipe, PipeTransform } from '@angular/core';
@Injectable({
  providedIn: 'root',
})
@Pipe({
  name: 'linkDocuments',
})
export class LinkDocumentsPipe implements PipeTransform {
  transform(ezShareID: string, page: number): unknown {
    return `https://www.iadb.org/document.cfm?id=${ezShareID}&contdisp=inline#page=${page}`;
  }
}
